<template>
    <div class="bookStatistics">
        <div class="title">文献标引统计</div>
        <div class="chartView">
            <div class="box-chart" id='bookIndexStatistics1'>
                <div class="line-view" v-for="(item, index) of records" :key='index'>
                    <div class="line-title">{{item.title}}</div>
                    <div class="progress">
                        <div class="progress-inner" :style="{'background': colors[index], width: item.count*100/countAll + '%'}"></div>
                    </div>
                    <div>{{item.count}}</div>
                </div>
            </div>
            <div class="box-chart" id='bookIndexStatistics2'></div>
        </div>
    </div>
</template>

<script>
import statisticsApi from '@/api/statistics'

export default {
    data () {
        return {
            records: [],
            colors: [
                'rgb(145,204,117)',
                'rgb(250,200,88)',
                'rgb(239,110,110)',
                'rgb(122,195,224)',
                'rgb(115,192,222)',
                'rgb(252,132,82)',
                'rgb(154,96,180)',
                'rgb(84,112,198)',
                'rgb(247,44,91)'
            ],
            countAll: 1
        }
    },
    mounted () {
        this.getData();
    },
    methods: {
        getData () {
            let that = this;
            that.records = [];

            statisticsApi.getSubItemStatistics({
                type: 'book',
                libraryCode: this.global.getLibraryInfos().code
            }).then(response => {
                console.log(response);
                if (response.code === 200) {
                    // that.records = response.data;
                    that.countAll = 0;
                    for (let key in response.data) {
                        if (key === '全部数据') {
                            continue;
                        }
                        that.records.push({
                            title: key,
                            count: response.data[key]
                        });
                        that.countAll += response.data[key];
                    }
                    that.setChart();
                }
            })
        },
        setChart () {
            let chart = this.$echarts.init(document.getElementById('bookIndexStatistics2'), 'light', { renderer: 'svg' });

            let data = [];
            for (let item of this.records) {
                if (item.title === '全部数据') {
                    continue;
                }
                data.push({
                    name: item.title,
                    value: item.count
                });
            }

            let option = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '0%',
                    left: 'center'
                },
                color: this.colors,
                graphic: {
                    type: 'text',
                    left: 'center',
                    top: 'center',
                    style: {
                        text: '总数\n\n' + this.countAll,
                        textAlign: 'center',
                        width: 30,
                        height: 30,
                        fontSize: 16
                    }
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['30%', '60%'],
                        avoidLabelOverlap: true,
                        label: {
                            show: true,
                            // position: 'center'
                            formatter: '{b} {d}%'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '16',
                                fontWeight: 'normal'
                            }
                        },
                        data
                    }
                ]
            };
            chart.setOption(option);
        }
    }
};
</script>

<style lang='less' scoped>
@import "~@/styles/variables.less";
.bookStatistics {
    width: 100%;
    height: 100%;
    position: relative;

    .title {
        font-size: 16 * @uw;
        color: #8d5e1a;
        margin: 0 * @uh 0px 20 * @uh 10 * @uw;
        padding-top: 10 * @uh;
    }

    .chartView {
        width: 100%;
        height: 95%;
        display: flex;

        .box-chart {
            width: 50%;
            height: 100%;
            padding-left: 20 * @uw;

            .line-view {
                display: flex;
                align-items: center;
                margin-bottom: 15 * @uh;

                .line-title {
                    width: 120 * @uw;
                    display: flex;
                    flex-direction: row-reverse;
                }

                .progress {
                    width: 50%;
                    border-radius: 5 * @uw;
                    height: 7 * @uh;
                    margin-left: 10 * @uw;
                    margin-right: 10 * @uw;
                    background: #dfdedd;

                    .progress-inner {
                        height: 100%;;
                        border-radius: 5 * @uw;
                    }
                }
            }
        }
    }
}
</style>
